$("#headingoption1").hover(
    function() {
        $(this).addClass('active');
        section1Show();
    }
);
$("#headingoption2").hover(
    function() {
        $(this).addClass('active');
        section2Show();
    }
);
$("#headingoption3").hover(
    function() {
        $(this).addClass('active');
        section3Show();
    }
);
$("#headingoption4").hover(
    function() {
        $(this).addClass('active');
        section4Show();
    }
);

function section1Show(){
    $("#headingoption2").removeClass('active');
    $("#headingoption3").removeClass('active');
    $("#headingoption4").removeClass('active');

    $("#picture1").css('z-index', '101');
    $("#picture1").css('opacity', '1');

    $("#picture2").css('z-index', '100');
    $("#picture2").css('opacity', '0');

    $("#picture3").css('z-index', '100');
    $("#picture3").css('opacity', '0');

    $("#picture4").css('z-index', '100');
    $("#picture4").css('opacity', '0');

    $("#text1").css('z-index', '101');
    $("#text1").css('opacity', '1');

    $("#text2").css('z-index', '100');
    $("#text2").css('opacity', '0');

    $("#text3").css('z-index', '100');
    $("#text3").css('opacity', '0');

    $("#text4").css('z-index', '100');
    $("#text4").css('opacity', '0');
}
function section2Show(){
    $("#headingoption1").removeClass('active');
    $("#headingoption3").removeClass('active');
    $("#headingoption4").removeClass('active');

    $("#picture2").css('z-index', '101');
    $("#picture2").css('opacity', '1');

    $("#picture1").css('z-index', '100');
    $("#picture1").css('opacity', '0');

    $("#picture3").css('z-index', '100');
    $("#picture3").css('opacity', '0');

    $("#picture4").css('z-index', '100');
    $("#picture4").css('opacity', '0');

    $("#text2").css('z-index', '101');
    $("#text2").css('opacity', '1');

    $("#text1").css('z-index', '100');
    $("#text1").css('opacity', '0');

    $("#text3").css('z-index', '100');
    $("#text3").css('opacity', '0');

    $("#text4").css('z-index', '100');
    $("#text4").css('opacity', '0');
}

function section3Show(){
    $("#headingoption2").removeClass('active');
    $("#headingoption1").removeClass('active');
    $("#headingoption4").removeClass('active');

    $("#picture3").css('z-index', '101');
    $("#picture3").css('opacity', '1');

    $("#picture2").css('z-index', '100');
    $("#picture2").css('opacity', '0');

    $("#picture1").css('z-index', '100');
    $("#picture1").css('opacity', '0');

    $("#picture4").css('z-index', '100');
    $("#picture4").css('opacity', '0');

    $("#text3").css('z-index', '101');
    $("#text3").css('opacity', '1');

    $("#text2").css('z-index', '100');
    $("#text2").css('opacity', '0');

    $("#text1").css('z-index', '100');
    $("#text1").css('opacity', '0');

    $("#text4").css('z-index', '100');
    $("#text4").css('opacity', '0');
}

function section4Show(){
    $("#headingoption2").removeClass('active');
    $("#headingoption3").removeClass('active');
    $("#headingoption1").removeClass('active');

    $("#picture4").css('z-index', '101');
    $("#picture4").css('opacity', '1');

    $("#picture2").css('z-index', '100');
    $("#picture2").css('opacity', '0');

    $("#picture3").css('z-index', '100');
    $("#picture3").css('opacity', '0');

    $("#picture1").css('z-index', '100');
    $("#picture1").css('opacity', '0');

    $("#text4").css('z-index', '101');
    $("#text4").css('opacity', '1');

    $("#text2").css('z-index', '100');
    $("#text2").css('opacity', '0');

    $("#text3").css('z-index', '100');
    $("#text3").css('opacity', '0');

    $("#text1").css('z-index', '100');
    $("#text1").css('opacity', '0');
}

// function section2Show(){
//     $("#headingoption1").removeClass('active');
//         $("#headingoption3").removeClass('active');
//         $("#headingoption4").removeClass('active');

//         $("#picture2").css('display', 'block');
//         $("#picture2").css('visibility', 'visible');
//         $("#picture2").css('opacity', '1');

//         $("#picture1").css('display', 'none');
//         $("#picture1").css('visibility', 'hidden');
//         $("#picture1").css('opacity', '0');

//         $("#picture3").css('display', 'none');
//         $("#picture3").css('visibility', 'hidden');
//         $("#picture3").css('opacity', '0');

//         $("#picture4").css('display', 'none');
//         $("#picture4").css('visibility', 'hidden');
//         $("#picture4").css('opacity', '0');

//         $("#text2").css('display', 'flex');
//         $("#text2").css('visibility', 'visible');
//         $("#text2").css('opacity', '1');

//         $("#text1").css('display', 'none');
//         $("#text1").css('visibility', 'hidden');
//         $("#text1").css('opacity', '0');

//         $("#text3").css('display', 'none');
//         $("#text3").css('visibility', 'hidden');
//         $("#text3").css('opacity', '0');

//         $("#text4").css('display', 'none');
//         $("#text4").css('visibility', 'hidden');
//         $("#text4").css('opacity', '0');
// }

// function section3Show(){
//     $("#headingoption2").removeClass('active');
//         $("#headingoption1").removeClass('active');
//         $("#headingoption4").removeClass('active');

//         $("#picture3").css('display', 'block');
//         $("#picture3").css('visibility', 'visible');
//         $("#picture3").css('opacity', '1');

//         $("#picture2").css('display', 'none');
//         $("#picture2").css('visibility', 'hidden');
//         $("#picture2").css('opacity', '0');

//         $("#picture1").css('display', 'none');
//         $("#picture1").css('visibility', 'hidden');
//         $("#picture1").css('opacity', '0');

//         $("#picture4").css('display', 'none');
//         $("#picture4").css('visibility', 'hidden');
//         $("#picture4").css('opacity', '0');

//         $("#text3").css('display', 'flex');
//         $("#text3").css('visibility', 'visible');
//         $("#text3").css('opacity', '1');

//         $("#text2").css('display', 'none');
//         $("#text2").css('visibility', 'hidden');
//         $("#text2").css('opacity', '0');

//         $("#text1").css('display', 'none');
//         $("#text1").css('visibility', 'hidden');
//         $("#text1").css('opacity', '0');

//         $("#text4").css('display', 'none');
//         $("#text4").css('visibility', 'hidden');
//         $("#text4").css('opacity', '0');
// }

// function section4Show(){
//     $("#headingoption2").removeClass('active');
//         $("#headingoption3").removeClass('active');
//         $("#headingoption1").removeClass('active');

//         $("#picture4").css('display', 'block');
//         $("#picture4").css('visibility', 'visible');
//         $("#picture4").css('opacity', '1');

//         $("#picture2").css('display', 'none');
//         $("#picture2").css('visibility', 'hidden');
//         $("#picture2").css('opacity', '0');

//         $("#picture3").css('display', 'none');
//         $("#picture3").css('visibility', 'hidden');
//         $("#picture3").css('opacity', '0');

//         $("#picture1").css('display', 'none');
//         $("#picture1").css('visibility', 'hidden');
//         $("#picture1").css('opacity', '0');

//         $("#text4").css('display', 'flex');
//         $("#text4").css('visibility', 'visible');
//         $("#text4").css('opacity', '1');

//         $("#text2").css('display', 'none');
//         $("#text2").css('visibility', 'hidden');
//         $("#text2").css('opacity', '0');

//         $("#text3").css('display', 'none');
//         $("#text3").css('visibility', 'hidden');
//         $("#text3").css('opacity', '0');

//         $("#text1").css('display', 'none');
//         $("#text1").css('visibility', 'hidden');
//         $("#text1").css('opacity', '0');
// }